import React from 'react';
import Markdown from 'markdown-to-jsx';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Box, Stack, Text } from '@atlaskit/primitives';
import Anchor from '@atlaskit/primitives/anchor';
import { FormattedMessage, useIntl } from '@atlassian/jira-intl';
import { TransitionHomeContentBox } from '../../../common/ui/transition-home/content-box/index.tsx';
import { TransitionHomeHeader } from '../../../common/ui/transition-home/header/index.tsx';
import { messages as stepMessages } from '../../../common/ui/transition-home/step/messages.tsx';
import {
	UnorderedList,
	UnorderedListItem,
} from '../../../common/ui/transition-home/unordered-list/index.tsx';
import taskMessages from '../../../common/utils/tasks/messages.tsx';
import { useTeams } from '../../../services/store/teams/index.tsx';
import TaskOneIllustrationDark from './assets/task-one-illustration-dark.png';
import TaskOneIllustration from './assets/task-one-illustration.png';
import { messages } from './messages.tsx';
import { TeamsTable } from './teams-table/index.tsx';

export const TeamsConceptStep = () => {
	const { formatMessage } = useIntl();

	const [{ hasTeams, teams }] = useTeams();

	return (
		<Stack space="space.250">
			<TransitionHomeHeader
				title={<FormattedMessage {...stepMessages.teamsTitleNonFinal} />}
				description={<FormattedMessage {...stepMessages.teamsDescriptionNonFinal} />}
			/>

			{/* Task One */}
			<TransitionHomeContentBox
				illustration={<Image src={TaskOneIllustration} srcDark={TaskOneIllustrationDark} alt="" />}
			>
				<Stack space="space.200">
					<Heading as="h2" size="small">
						<FormattedMessage {...taskMessages.teamsTaskOneNonFinal} />
					</Heading>
					<Box>
						<Markdown
							options={{
								overrides: {
									ul: { component: UnorderedList },
									li: { component: UnorderedListItem },
								},
							}}
						>
							{formatMessage(messages.taskOneDescriptionNonFinal)}
						</Markdown>
					</Box>
					<Box>
						<Anchor
							href="https://support.atlassian.com/jira-service-management-cloud/docs/launch-your-team-operations/"
							target="_blank"
						>
							<FormattedMessage {...messages.taskOneCtaNonFinal} />
						</Anchor>
					</Box>
				</Stack>
			</TransitionHomeContentBox>

			{hasTeams && (
				<TransitionHomeContentBox>
					<Stack space="space.200">
						<Heading as="h2" size="small">
							<FormattedMessage {...taskMessages.teamsTaskTwoNonFinal} />
						</Heading>
						<Stack space="space.150">
							<Markdown>{formatMessage(messages.taskTwoDescriptionNonFinal)}</Markdown>
							<Stack space="space.100">
								<Text as="p" color="color.text.subtlest">
									{formatMessage(messages.tableDescriptionTextNonFinal)}
								</Text>
								<TeamsTable teams={teams} />
							</Stack>
						</Stack>
					</Stack>
				</TransitionHomeContentBox>
			)}
		</Stack>
	);
};
